/*
 * IMPORTS
 */
import React, { useState } from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useHistory } from 'react-router-dom' // Npm: React router dom.
import { HiBookOpen, HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@mui/material' // Npm: Material-UI components.


/*
 * OBJECTS
 */
const Index = ({
  keywordDirectoryId,
  onKeywordDirectoryUpdate,
  onKeywordDirectoryDelete,
  PassOnUpdate
}) => {
  // Hook assignment.
  const _historyRef = useHistory()

  // State for menu anchor
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  // Handle menu open
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  // Handle menu close
  const handleClose = () => {
    setAnchorEl(null)
  }

  // Return component.
  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{
          margin: 'auto',
          borderRadius: '8px',
          color: 'gray.500',
          bgcolor: 'transparent'
        }}>
        <HiPencil size={18} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >

        <MenuItem
          sx={{ gap: 0 }}
          onClick={() => {
            // Push keywordDirectory id to url.
            PassOnUpdate({ keywordDirectoryId })

            // Execute handler.
            onKeywordDirectoryUpdate()

            // Close menu
            handleClose()
          }}
        >
          <ListItemIcon >
            <HiPencil size={18} />
          </ListItemIcon>
          <ListItemText>Edit Folder</ListItemText>
        </MenuItem>

        <MenuItem
          sx={{ gap: 0 }}
          onClick={() => {
            // Push keywordDirectory id to url.
            PassOnUpdate({ keywordDirectoryId })

            // Execute handler.
            onKeywordDirectoryDelete()

            // Close menu
            handleClose()
          }}
        >
          <ListItemIcon >
            <HiTrash size={18} />
          </ListItemIcon>
          <ListItemText>Delete Folder</ListItemText>
        </MenuItem>

        <MenuItem
          sx={{ gap: 0 }}
          onClick={() => {
            // Push keywordDirectory id to url.
            PassOnUpdate({ keywordDirectoryId })

            // Execute handler.
            _historyRef.push('/keywords/keyword')

            // Close menu
            handleClose()
          }}
        >
          <ListItemIcon >
            <HiBookOpen size={18} />
          </ListItemIcon>
          <ListItemText>Manage Keywords</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'keywordDirectoryId': PropTypes.string,
  'onKeywordDirectoryUpdate': PropTypes.func,
  'onKeywordDirectoryDelete': PropTypes.func,
  'PassOnUpdate': PropTypes.func
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
